export default "__VITE_ASSET__D1ZoaOgf__"